export default function UserSessions() {
    return (
        <div>
            <h1>User Sessions</h1>
            <h6>user\Sessions.jsx</h6>
        </div>
    )
}